const BKMenu = [
    {
        id: 1,
        title: '总览（收录统计）',
        goto: { path: '/book/index' },
        class: 'is-open',
    }, {
        id: 2,
        title: '书夹分类',
        goto: { path: '/book/cats' },
        class: 'is-open',
    }, {
        id: 3,
        title: '我的书单',
        goto: { path: '/book/list' },
        class: '',
    }, {
        id: 4,
        title: '成员管理',
        goto: { path: '/book/members' },
        class: '',
    }, {
        id: 5,
        title: '邀请好友',
        goto: { path: '/book/invite' },
        class: '',
    }, {
        id: 6,
        title: '操作历史',
        goto: { path: '/book/loglist' },
        class: '',
    }
]

export default BKMenu